import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "configuration-form" }
const _hoisted_2 = { role: "group" }
const _hoisted_3 = { role: "group" }
const _hoisted_4 = { role: "group" }
const _hoisted_5 = { role: "group" }
const _hoisted_6 = { role: "group" }
const _hoisted_7 = { role: "group" }
const _hoisted_8 = { role: "group" }
const _hoisted_9 = { role: "group" }
const _hoisted_10 = { role: "group" }
const _hoisted_11 = { role: "group" }
const _hoisted_12 = {
  key: 0,
  role: "group"
}
const _hoisted_13 = { role: "group" }
const _hoisted_14 = { role: "group" }
const _hoisted_15 = {
  key: 1,
  role: "group",
  class: "share-section"
}
const _hoisted_16 = { class: "input-group" }
const _hoisted_17 = ["value"]
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_feedback = _resolveComponent("b-form-feedback")!
  const _component_BFormValidFeedback = _resolveComponent("BFormValidFeedback")!
  const _component_b_badge = _resolveComponent("b-badge")!
  const _component_b_form_text = _resolveComponent("b-form-text")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[44] || (_cache[44] = _createElementVNode("h4", { class: "title" }, "Configuration", -1)),
    _cache[45] || (_cache[45] = _createElementVNode("p", { class: "subtitle" }, "Please configure your gitlab pipeline dashboard.", -1)),
    _createVNode(_component_b_card, { class: "text-dark" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_form, {
          onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
          ref: "form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { for: "input-url" }, [
                _createTextVNode("GitLab URL: "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_b_form_input, {
                id: "input-url",
                ref: "input-url",
                modelValue: _ctx.formData.url,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.url) = $event)),
                required: "",
                state: _ctx.validateInput('input-url'),
                trim: "",
                type: "url",
                placeholder: "",
                "aria-describedby": "input-url-feedback",
                "aria-invalid": _ctx.validateInput('input-url')
              }, null, 8, ["modelValue", "state", "aria-invalid"]),
              _createVNode(_component_b_form_feedback, {
                class: "feedback",
                id: "input-url-feedback"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode(" Please enter a valid URL. ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { for: "input-url" }, [
                _createTextVNode(" API Access Token: "),
                _createElementVNode("span", { class: "text-danger" }, "*"),
                _createElementVNode("br"),
                _createElementVNode("span", { class: "hint" }, [
                  _createTextVNode("Retrieve 'read_api' token from "),
                  _createElementVNode("a", {
                    href: "test",
                    xxhref: "$data.formData.url+'/-/user_settings/personal_access_tokens'"
                  }, "/-/user_settings/personal_access_tokens")
                ])
              ], -1)),
              _createVNode(_component_b_form_input, {
                id: "input-token",
                ref: "input-token",
                modelValue: _ctx.formData.token,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.token) = $event)),
                required: "",
                state: _ctx.validateInput('input-token'),
                trim: "",
                autocomplete: "none",
                type: "password",
                "aria-describedby": "input-token-feedback",
                "aria-invalid": _ctx.validateInput('input-token')
              }, null, 8, ["modelValue", "state", "aria-invalid"]),
              _createVNode(_component_BFormValidFeedback, {
                class: "feedback",
                id: "input-token-feedback"
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode(" Enter a API access token ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { for: "input-url" }, [
                _createTextVNode("Groups: "),
                _createElementVNode("span", { class: "hint" }, "separated by semicolon: ';'")
              ], -1)),
              _createVNode(_component_b_form_input, {
                id: "input-group",
                ref: "input-group",
                modelValue: _ctx.formData.groups,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.groups) = $event)),
                required: !_ctx.formData.groups && !_ctx.formData.projects,
                trim: "",
                type: "text",
                placeholder: "supers; winners",
                "aria-describedby": "input-group-text"
              }, null, 8, ["modelValue", "required"]),
              _createVNode(_component_b_form_text, {
                class: "feedback badges",
                id: "input-group-text"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitNames(_ctx.formData.groups), (group, key) => {
                    return (_openBlock(), _createBlock(_component_b_badge, {
                      variant: "primary",
                      pill: "",
                      key: key
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(group), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { for: "input-url" }, [
                _createTextVNode("Projects: "),
                _createElementVNode("br"),
                _createElementVNode("span", { class: "hint" }, "exact path with namespace: e.g. lkwg82/gitlab-pipeline-dashboard, separated by semicolon: ';'")
              ], -1)),
              _createVNode(_component_b_form_input, {
                id: "input-projects",
                ref: "input-projects",
                modelValue: _ctx.formData.projects,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.projects) = $event)),
                trim: "",
                type: "text",
                placeholder: "alpha; beta",
                "aria-describedby": "input-projects-text"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_b_form_text, {
                class: "feedback badges",
                id: "input-projects-text"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitNames(_ctx.formData.projects), (project, key) => {
                    return (_openBlock(), _createBlock(_component_b_badge, {
                      variant: "info",
                      pill: "",
                      key: key
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(project), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[22] || (_cache[22] = _createElementVNode("label", { for: "group-groups-checkbox" }, "group by groups ", -1)),
              _createVNode(_component_b_form_checkbox, {
                id: "group-groups-checkbox",
                ref: "group-groups",
                onChange: _ctx.onSelectGroupingByGroups,
                modelValue: _ctx.formData.group_by_groups,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.group_by_groups) = $event)),
                value: true,
                "unchecked-value": false,
                "aria-describedby": "input-group-groups-checkbox"
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createTextVNode("group projects by group vertically ")
                ])),
                _: 1
              }, 8, ["onChange", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { for: "group-namespaces-checkbox" }, "group by namespaces ", -1)),
              _createVNode(_component_b_form_checkbox, {
                id: "group-namespaces-checkbox",
                ref: "group-namespaces",
                modelValue: _ctx.formData.group_by_namespaces,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.group_by_namespaces) = $event)),
                onChange: _ctx.onSelectGroupingByNamespace,
                value: true,
                "unchecked-value": false,
                "aria-describedby": "input-group-namespaces-checkbox"
              }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createTextVNode("group projects by namespace vertically ")
                ])),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { for: "include-shared-projects-checkbox" }, "include shared projects", -1)),
              _createVNode(_component_b_form_checkbox, {
                id: "include-shared-projects-checkbox",
                ref: "include-shared-projects",
                modelValue: _ctx.formData.include_shared_projects,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.include_shared_projects) = $event)),
                value: true,
                "unchecked-value": false,
                "aria-describedby": "input-shared-projects-checkbox"
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createTextVNode("include shared projects ")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "experiments" }, [
              _createElementVNode("hr"),
              _createTextVNode(" 🏗 Experimente "),
              _createElementVNode("span", { class: "s1" }, "😁"),
              _createElementVNode("hr")
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              _cache[28] || (_cache[28] = _createElementVNode("label", { for: "order-by-failures-checkbox" }, [
                _createTextVNode("order by failures "),
                _createElementVNode("sup", null, "BETA")
              ], -1)),
              _createVNode(_component_b_form_checkbox, {
                id: "order-by-failures-checkbox",
                ref: "order-by-failures",
                modelValue: _ctx.formData.beta_order_by_failures_first,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.beta_order_by_failures_first) = $event)),
                "aria-describedby": "input-order-by-failures-checkbox"
              }, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [
                  _createTextVNode("order by failures (failures first) ")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { for: "protected-branches-checkbox" }, [
                _createTextVNode("show only protected branches "),
                _createElementVNode("sup", null, "BETA")
              ], -1)),
              _createVNode(_component_b_form_checkbox, {
                id: "protected-branches-checkbox",
                ref: "show-only-protected-branches",
                modelValue: _ctx.formData.beta_show_only_protected_branches,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.beta_show_only_protected_branches) = $event)),
                "aria-describedby": "protected-branches-checkbox"
              }, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createTextVNode("show last pipeline status per protected branch instead of status of last pipeline for project ")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { for: "show-schedules-builds-checkbox" }, [
                _createTextVNode("show status of schedules builds"),
                _createElementVNode("sup", null, "BETA")
              ], -1)),
              _createVNode(_component_b_form_checkbox, {
                id: "show-schedules-builds-checkbox",
                ref: "show-schedules-builds",
                modelValue: _ctx.formData.beta_show_scheduled_builds,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.beta_show_scheduled_builds) = $event)),
                "aria-describedby": "show-schedules-builds-checkbox"
              }, {
                default: _withCtx(() => _cache[31] || (_cache[31] = [
                  _createTextVNode("shows status of last pipeline from active schedules ")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_ctx.show_snow_fun_config())
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", { for: "show-snow-checkbox" }, [
                    _createTextVNode("show snow because ... ?"),
                    _createElementVNode("sup", null, "ALPHA")
                  ], -1)),
                  _createVNode(_component_b_form_checkbox, {
                    id: "show-snow-checkbox",
                    ref: "show-snow",
                    modelValue: _ctx.formData.alpha_show_snow,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.alpha_show_snow) = $event)),
                    "aria-describedby": "show-snow-checkbox"
                  }, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                      _createTextVNode("let it snow ")
                    ])),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _cache[36] || (_cache[36] = _createElementVNode("label", { for: "show-history-checkbox" }, [
                _createTextVNode("show pipeline history"),
                _createElementVNode("sup", null, "ALPHA")
              ], -1)),
              _createVNode(_component_b_form_checkbox, {
                id: "show-history-checkbox",
                ref: "show-history",
                modelValue: _ctx.formData.beta_show_history,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.beta_show_history) = $event)),
                "aria-describedby": "show-history-checkbox"
              }, {
                default: _withCtx(() => _cache[35] || (_cache[35] = [
                  _createTextVNode("shows status of the last 20 pipelines when job is failed ")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[38] || (_cache[38] = _createElementVNode("label", { for: "no-polling-checkbox" }, [
                _createTextVNode("deactivate polling pipeline updates (needs browser refresh)"),
                _createElementVNode("sup", null, "BETA")
              ], -1)),
              _createVNode(_component_b_form_checkbox, {
                id: "no-polling-checkbox",
                ref: "no-polling",
                modelValue: _ctx.formData.beta_no_polling,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.beta_no_polling) = $event)),
                "aria-describedby": "no-polling-checkbox"
              }, {
                default: _withCtx(() => _cache[37] || (_cache[37] = [
                  _createTextVNode("avoids periodic updates in background (each updates needs a page refresh) ")
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_ctx.shareUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _cache[39] || (_cache[39] = _createElementVNode("hr", null, null, -1)),
                  _cache[40] || (_cache[40] = _createElementVNode("label", null, "📤 Share Config URL:", -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      value: _ctx.shareUrl,
                      readonly: "",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => ($event.target.select())),
                      placeholder: "Generated share URL will appear here..."
                    }, null, 8, _hoisted_17),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn", 
                _ctx.copyButtonState === 'copied'
                  ? 'btn-success'
                  : 'btn-outline-secondary'
              ]),
                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.copyShareUrl && _ctx.copyShareUrl(...args))),
                      disabled: !_ctx.shareUrl
                    }, _toDisplayString(_ctx.copyButtonState === "copied" ? "✅ Copied!" : "📋 Copy"), 11, _hoisted_18)
                  ]),
                  _cache[41] || (_cache[41] = _createElementVNode("small", { class: "text-muted" }, " Share this URL to let others use your group/project configuration ", -1))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_b_button, {
              type: "submit",
              variant: "primary",
              xvariant: "checkValidity() ? 'primary' : 'outline-primary'",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => _cache[42] || (_cache[42] = [
                _createTextVNode(" Save ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]),
      _: 1
    })
  ]))
}